import { RelatedTag } from '@empathy/search-types';
import { QuerySignalsState } from '../../../models';
import { QUERY_SIGNALS_MUTATIONS_KEYS } from '../query-signals.const';
import { QuerySignalsMutation } from '../query-signals.interfaces';

export class ToggleRelatedTagMutation implements QuerySignalsMutation {

  mutations = {
    [QUERY_SIGNALS_MUTATIONS_KEYS.toggleRelatedTag]: (querySignalsState: QuerySignalsState, relatedTag: RelatedTag) =>
      relatedTag.selected = !relatedTag.selected
  };
}
